import styled from 'styled-components';
import {theme} from '../../../styles/darkTheme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const InputField = styled.input`
  width: 100%;
  font-size: 18px;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  background: ${theme.white};
  border: 1px solid ${theme.inputBorder};
  box-sizing: border-box;
  border-radius: 8px;
  outline: none;
`;
